import * as DataGenerator from 'data-generator-retail';

export type ThemeName = 'light' | 'dark';

export type Category = DataGenerator.Category;
export type Product = DataGenerator.Product;
export type Customer = DataGenerator.Customer;
export type Order = DataGenerator.Order;
export type Invoice = DataGenerator.Invoice;
export type Review = DataGenerator.Review;
export type BasketItem = DataGenerator.BasketItem;

export type RESTFullResponse<T> = {
    status: number;
    message: string;
    data: T;
};

declare global {
    interface Window {
        restServer: any;
    }
}

export type PageResponse<T> = {
    pageNum: number;
    pageSize: number;
    records: T[];
    total: number;
};

export type BlogCtrbItem = {
    category: number;
    contentType: number;
    coverImgLink: string;
    createTime: number;
    itemId: number;
    lastUpdTime: number;
    mrscId:string;
    reference: number[];
    remark: string;
    remitMoney: boolean;
    srcContent: string;
    status: number;
    summary: string;
    email: string;
    tags: number[];
    title: string;
    txtContent: string;
    videoLink: string;
    weblink: string;
}

export type BlogItem = {
    category: number;
    contentType: number;
    coverImgLink: string;
    createTime: number;
    itemId: number;
    lastUpdTime: number;
    mrscId:string;
    reference: number[];
    remark: string;
    remitMoney: boolean;
    srcContent: string;
    onList: number;
    summary: string;
    email: string;
    tags: number[];
    title: string;
    txtContent: string;
    videoLink: string;
    weblink: string;
}

export type BlogTag = {
    tagId: string;
    tagName: string;
}

export type Admin = {
    adminId: string;
    email: string;
    remark: string;
    authRoleName: string;
    expiredTime: number;
    createTime: number;
    updateTime: number;
    loginTime: number;
}

export type AdminRole = {
    roleId: number;
    roleName: string;
    permissions: AdminPermission[];
}

export type AdminPermission = {
    permissionId: number;
    permissionName: string;
    permissionKey: string;
}

export type MCampaign = {
    campaignId: number;
    name: string;
    description: string;
    coverImage: string;
    pageLink: string;
    createTime: number;
    startDate: number;
    endDate: number;
    logCount: number;
}

export type MCampaignLog = {
    logId: number;
    campaignId: number;
    email: string,
    createTime: number;
    toTop: boolean;
    eventId: number;
    userMail: string;
    realName: string;
    phoneNumber: string;
    leaveMessage: string;
    externalLink: string;
}

export type User = {
    adminId: string;
    email: string;
    authRole: number;
    remark: string;
    expireTime: number;
    loginTime: number;
    token: string;
    refreshToken: string;
}

export const LOCAL_STORAGE_KEY = {
    BLOGCTRBITEM_CREATE_HISTORY: 'blogCtrbItemCreateHistory',
    BLOGCTRBITEM_CREATE_CONVERTIMG_HISTORY: 'blogCtrbItemCreateCovertImgHistory',
    BLOGCTRBITEM_CREATE_SRCCONTENT_HISTORY: 'blogCtrbItemCreateSrcContentHistory',
    BLOGCTRBITEM_CREATE_TEXTCONTENT_HISTORY: 'blogCtrbItemCreateTextContentHistory',
    BLOGCTRBITEM_CREATE_UNIQUEID: 'blogCtrbItemCreateUniqueId',
}
